import React from "react"
import { RadioContainer, Label, SelectOption, Fill } from "./CheckboxElements"

const Checkbox = ({ id, name, value, checkedValue, handleRadioChange, label, ...otherProps }) => {
  return (
    <RadioContainer>
      <Label htmlFor={id}>
        {label}
        <SelectOption
          id={id}
          name={name}
          value={value}
          checked={checkedValue}
          onChange={handleRadioChange}
          {...otherProps}
        />
        <Fill />
      </Label>
    </RadioContainer>
  )
}

export default Checkbox
